// extracted by mini-css-extract-plugin
export default {"counter":"styles_counter__KTvBW","hover":"styles_hover__goUiM","fancy":"styles_fancy__u3k0-"};